import { render, staticRenderFns } from "./DataTableMobile.vue?vue&type=template&id=247b7ac1&scoped=true&"
import script from "./DataTableMobile.vue?vue&type=script&lang=js&"
export * from "./DataTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./DataTableMobile.vue?vue&type=style&index=0&id=247b7ac1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b7ac1",
  null
  
)

export default component.exports